/*
 * @Descripttion:
 * @version:
 * @Author: AowCt <awoct10@163.com>
 * @Date: 2023-08-29 10:09:27
 * @LastEditors: AowCt <awoct10@163.com>
 * @LastEditTime: 2024-07-04 16:27:47
 */
import request from '@/utils/request'

/**
 * 获取所有国家
 * @param { * } data
 * @returns
 */
export function getAllCountries (data) {
  return request({
    url: 'system/getAllCountries',
    method: 'post',
    data
  })
}

/**
 * 获取中国所有地区
 * @param { * } data
 * @returns
 */
export function getAllArea (data) {
  return request({
    url: 'system/getAllArea',
    method: 'post',
    data
  })
}

/**
 * 根据序列号获取项目类型
 * @param { serialNumber: '序列号' } data
 * @returns
 */
export function getModelBySerialNumber (data) {
  return request({
    url: 'system/getModelBySerialNumber',
    method: 'post',
    data
  })
}

/**
 * 根据序列号获取项目类型
 * @param {  } data
 * @returns
 */
export function submitInfo (data) {
  return request({
    url: 'Activation/submitInfo',
    method: 'post',
    data
  })
}

/**
 * 校验邀请码接口
 * @param { invitationCode } data
 * @returns
 */
export function checkInvitationCode (data) {
  return request({
    url: 'Activation/checkInvitationCode',
    method: 'post',
    data
  })
}

/**
 * angio 表单提交
 * @param {
 * lastName 名
 * firstName 姓
 * email 电子邮箱
 * institutionName 机构名称
 * profession 职业
 * product 产品
 * type   en：英文/cn：中文
 *  } data
 * @returns
 */
export function submitAngio (data) {
  return request({
    url: 'angio_ce/submit',
    method: 'post',
    data
  })
}

/**
 * 获取angio pdf接口
 * @param { id } data
 * @returns
 */
export function getAngioPdf (data) {
  return request({
    url: 'angio_ce/getPDF',
    method: 'post',
    data
  })
}

/**
 * imr 表单提交
 * @param {
 * lastName 名
 * firstName 姓
 * email 电子邮箱
 * institutionName 机构名称
 * profession 职业
 * product 产品
 * type   en：英文/cn：中文
 *  } data
 * @returns
 */
export function submitIMR (data) {
  return request({
    url: 'imr/submit',
    method: 'post',
    data
  })
}

/**
 * 获取angio pdf接口
 * @param { id } data
 * @returns
 */
export function getIMRPdf (data) {
  return request({
    url: 'imr/getPDF',
    method: 'post',
    data
  })
}
